import React, { PureComponent } from 'react';
import { string, func } from 'prop-types';
import AppFooter from '@active/react-ui/AppFooter';
import AppFooterText from '@active/react-ui/AppFooterText';
import AppFooterItemGroup from '@active/react-ui/AppFooterItemGroup';
import LinkButton from '@active/react-ui/LinkButton';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import noop from 'lodash/noop';
import find from 'lodash/find';
import { LOCAL_PREFIX } from '../../../../../shared/utils/commonUtils';
import linksInfo from './config';

const PAGEBANNER_PREFIX = `${LOCAL_PREFIX}banners.pagebanner.`;

class Footer extends PureComponent {
  static propTypes = {
    oneTrustUrl: string,
    optanonToken: string,
    oneTrustReadyCallBack: func,
    consentChangedCallback: func,
    trackingCallback: func,
    i18n: func,
  }

  static defaultProps = {
    oneTrustUrl: undefined,
    optanonToken: undefined,
    oneTrustReadyCallBack: noop,
    consentChangedCallback: noop,
    trackingCallback: noop,
  }

  state = {
    isShowOnetrust: false,
  }

  setOneTrust = () => {
    const { oneTrustReadyCallBack, consentChangedCallback } = this.props;
    this.setState({
      isShowOnetrust: true,
    });
    setTimeout(() => {
      window.OneTrust.OnConsentChanged((e) => {
        consentChangedCallback(e);
      });
    }, 3000);
    oneTrustReadyCallBack();
  }

  componentDidMount() {
    const { oneTrustUrl, optanonToken, oneTrustReadyCallBack } = this.props;
    if (oneTrustUrl && optanonToken) {
      const onReadyCallback = () => {
        window.addEventListener('load', this.setOneTrust);
        this.timeOut = setTimeout(() => {
          if (!this.state.isShowOnetrust) {
            this.setOneTrust();
          }
        }, 6000);
      };
      const scripts = document.getElementsByTagName('script');
      const sdkUrlScript = find(scripts, (o) => {
        return o.src.indexOf('otSDKStub.js') !== -1;
      });
      if (!sdkUrlScript) {
        this.prependOneTrustScript(oneTrustUrl, onReadyCallback, optanonToken);
      }
    } else {
      oneTrustReadyCallBack();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.setOneTrust);
    clearTimeout(this.timeOut);
  }

  prependOneTrustScript = (oneTrustUrl, onReadyCallback, optanonToken) => {
    const targetScript = document.createElement('script');
    targetScript.type = 'text/javascript';
    targetScript.async = false;
    targetScript.onload = () => {
      onReadyCallback && onReadyCallback();
    };
    targetScript.src = oneTrustUrl;
    targetScript.setAttribute('data-domain-script', optanonToken);
    targetScript.setAttribute('data-document-language', 'true');
    document.head.prepend(targetScript);
  };

  getCopyRight = () => {
    const currentYear = new Date().getFullYear().toString();
    const { i18n } = this.props;
    return (
      <React.Fragment>
        {
          linksInfo.map((l) => {
            const label = i18n(`${PAGEBANNER_PREFIX}footer.${l.id}`);
            return l.id === 'active'
              ? <AppFooterText>
                <LinkButton
                  onClick={this.handleClick(l)}
                  type="secondary-light"
                  key={l.id}
                  className="page-banner__footer__copyright">
                  <span>
                    ©&nbsp;
                    {currentYear}
                    &nbsp;
                    {label}
                  </span>
                </LinkButton>
              </AppFooterText> : null;
          },
          )
        }
      </React.Fragment>
    );
  }

  handleClick = ({ url, id }) => () => {
    window.open(url, '_blank');
    const { trackingCallback } = this.props;
    trackingCallback({ id: `cui.${id}.clicked` });
  }

  getCenterLinkDom = () => {
    const { isShowOnetrust } = this.state;
    const { i18n } = this.props;
    const cookieLabel = i18n(`${PAGEBANNER_PREFIX}footer.cookieSettings`);

    return (
      <React.Fragment>
        {
          linksInfo.map((l) => {
            const label = i18n(`${PAGEBANNER_PREFIX}footer.${l.id}`);
            return l.id !== 'active'
              ? <LinkButton
                type="secondary-light"
                onClick={this.handleClick(l)}
                key={l.id}>
                {label}
              </LinkButton> : null;
          },
          )
        }
        <LinkButton id='ot-sdk-btn' className={`link-btn link-btn-secondary-light ot-sdk-show-settings${isShowOnetrust ? ' optanon-show' : ''}`} data-ignore-geolocation="true">
          {cookieLabel}
        </LinkButton>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="page-banner__footer">
        <AppFooter>
          <AppFooterItemGroup>
            {this.getCenterLinkDom()}
            {this.getCopyRight()}
          </AppFooterItemGroup>
        </AppFooter>
      </div>
    );
  }
}

export default withI18n(Footer);
